import { render, staticRenderFns } from "./goodsCard.vue?vue&type=template&id=3a01e514&scoped=true"
import script from "./goodsCard.vue?vue&type=script&lang=ts"
export * from "./goodsCard.vue?vue&type=script&lang=ts"
import style0 from "./goodsCard.vue?vue&type=style&index=0&id=3a01e514&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a01e514",
  null
  
)

export default component.exports